import endpoints from 'constants/endpoints';

export const dashboardForPayeeKeys = {
  all: ['dashboard-for-payee'],
  byAgent: agentId => [...dashboardForPayeeKeys.all, agentId]
};

/**
 * request for one payee's commission dashboard (trend + carrier mix)
 * @param agentId - zoho id of the payee
 */
export function dashboardForPayeeRequest(agentId) {
  return {
    path: endpoints?.aws?.dashboardForPayee,
    params: { agent: agentId }
  };
}
